import React, { useState } from "react";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import TeamService from "services/TeamService";
import UserDefaultAvatar from "assets/img/user.svg";
import { useToasts } from "react-toast-notifications";
import RejectReasonDialog from "components/RejectReasonDialog";
import { useInvitationsContext } from "store/contexts/invitationContext";

export default ({ invite, onAccept, onReject }) => {
  const { addToast } = useToasts();
  const {
    rejectModalOpen,
    setRejectModalOpen,
    setRejectInviteCode,
    closeInviations,
    rejectInviteCode,
  } = useInvitationsContext();
  const [disabled_button, setDisabled_Button] = useState(false);
  const [acceptButton, setAcceptButton] = useState(false);
  const [rejectButton, setRejectButton] = useState(false);

  const rejectInvitation = async (reason, invite_code) => {
    if (invite_code) {
      setDisabled_Button(true);
      setRejectButton(true);

      try {
        await TeamService.rejectTeamInvitation(invite_code, reason);
        if (typeof onReject === "function") {
          onReject(invite_code);
        }

        setRejectButton(false);
        addToast("You have rejected your invitation ", { appearance: "error" });
        closeInviations();
      } catch (e) {
        console.log(e);
      }
    }
  };

  const acceptInvitation = async (inviteCode) => {
    setDisabled_Button(true);
    setAcceptButton(true);

    try {
      var response = await TeamService.acceptTeamInvitation(inviteCode);

      if (typeof onAccept === "function") {
        onAccept(inviteCode, response.data.data);
      }

      addToast("You have accepted the team invitation ", {
        appearance: "success",
      });
      setAcceptButton(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleRejectReason = async (invite_code) => {
    try {
      setRejectInviteCode(invite_code);
      await setRejectModalOpen(true);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <RejectReasonDialog
        rejectModalOpen={rejectModalOpen}
        setRejectModalOpen={setRejectModalOpen}
        rejectInvitation={rejectInvitation}
        rejectInviteCode={rejectInviteCode}
      />
      <div className="invitation-box team-invitation f-left">
        <div className="img_user">
          <img
            className="mw-40 invitationUserAvatar"
            src={invite.invitor.avatar ?? UserDefaultAvatar}
            alt={`${invite?.invitor.full_name}`}
          />
        </div>
        <div className="invitation-data">
          <div className="invitation-text">
            {invite?.invitor.full_name} has invited you to join a team
            <span className="n-team-name fw-600"> {invite?.team.name}</span>
          </div>
          {/* <small className="post_time color-light">9 min ago</small> */}
          <div className="buttons-accept-reject mt-1 mb-2">
            <Button
              onClick={() => handleRejectReason(invite.invitation_code)}
              buttonClass="small-reject-btn me-2"
              disabled={disabled_button && true}
              name={
                !rejectButton ? "Reject" : <Loader width={10} height={10} />
              }
            />
            <Button
              buttonClass="small-accept-btn"
              onClick={() => acceptInvitation(invite.invitation_code)}
              disabled={disabled_button && true}
              name={
                !acceptButton ? "Accept" : <Loader width={10} height={10} />
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};
